import { render } from "./Recommend.vue?vue&type=template&id=65b4ebda&scoped=true"
import script from "./Recommend.vue?vue&type=script&lang=js"
export * from "./Recommend.vue?vue&type=script&lang=js"

import "./Recommend.vue?vue&type=style&index=0&id=65b4ebda&scoped=true&lang=stylus"
import "./Recommend.vue?vue&type=style&index=1&id=65b4ebda&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-65b4ebda"

export default script